import { useTranslation } from 'react-i18next';

export default function SalonSection() {
  const { t } = useTranslation();
  const message = encodeURIComponent(t('whatsapp.message'));

  return (
    <section id="salon" className="py-16 md:py-24 bg-dark-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-champagne-400 text-xs font-medium tracking-[0.2em] uppercase mb-3">
            {t('salon.title')}
          </p>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3">
            {t('salon.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {/* Info Card */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/99522d9a3a4519144bb99e3bc03ec0b1.jpeg"
                alt="Cemil Kuaför Logo"
                className="h-14 w-14 rounded-full object-cover"
              />
              <div>
                <h3 className="text-white font-bold text-lg">{t('salon.name')}</h3>
                <p className="text-champagne-400 text-sm">Hair Design</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-champagne-400 flex-shrink-0">
                  <i className="ri-map-pin-line" />
                </div>
                <div>
                  <p className="text-white text-sm font-medium">{t('salon.address')}</p>
                  <p className="text-white/50 text-sm">{t('salon.city')}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-champagne-400 flex-shrink-0">
                  <i className="ri-phone-line" />
                </div>
                <div>
                  <a
                    href={`tel:+905313459987`}
                    className="text-white text-sm font-medium hover:text-champagne-400 transition-colors"
                  >
                    {t('salon.phone')}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-champagne-400 flex-shrink-0">
                  <i className="ri-instagram-line" />
                </div>
                <div>
                  <a
                    href="https://instagram.com/cemilkuaformarmaris"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm font-medium hover:text-champagne-400 transition-colors"
                  >
                    {t('salon.instagram')}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-champagne-400 flex-shrink-0">
                  <i className="ri-time-line" />
                </div>
                <div>
                  <p className="text-white/80 text-sm">{t('salon.hours')}</p>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3">
              <a
                href={`https://wa.me/905313459987?text=${message}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 flex-1 bg-champagne-500 text-dark-950 py-3 rounded-full font-semibold text-sm hover:bg-champagne-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg" />
                {t('whatsapp.cta')}
              </a>
              <a
                href="https://maps.google.com/?q=Marmaris+Tepe+Mahallesi"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 flex-1 border border-white/20 text-white py-3 rounded-full font-medium text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-map-line" />
                {t('salon.getDirections')}
              </a>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="rounded-2xl overflow-hidden border border-white/10 aspect-[4/3] lg:aspect-auto">
            <iframe
              title="Salon Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3063.5!2d28.2602!3d36.8565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDUxJzIzLjQiTiAyOMKwMTUnMzYuNyJF!5e0!3m2!1sen!2str!4v1600000000000"
              className="w-full h-full min-h-[300px] lg:min-h-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}